const Component = () => import('./DeliveryFrequency');

// eslint-disable-next-line import/prefer-default-export
export { Component };
